
import { useCallback, useEffect } from 'react';
import type { CopywritingStep } from './types';
import { useSmartCopywritingState } from './hooks/useSmartCopywritingState';
import { useAudienceLogic } from './hooks/useAudienceLogic';
import { useScenarioLogic } from './hooks/useScenarioLogic';
import { useCopyLogic } from './hooks/useCopyLogic';
import { useProjectLogic } from './hooks/useProjectLogic';

export const useSmartCopywriting = (projectId?: number) => {
    const { state, setState, setLoading } = useSmartCopywritingState();

    const { analyzeAudiences, selectAudiences } = useAudienceLogic(state, setState, setLoading);
    const { recommendScenarios, selectScenarios } = useScenarioLogic(state, setState, setLoading);
    const { generateCopy, regenerateSingleFABE } = useCopyLogic(state, setState, setLoading);
    const { loadProject, saveVersion } = useProjectLogic(state, setState, setLoading);

    // 当传入 projectId 时自动加载项目
    useEffect(() => {
        if (projectId && !state.project) {
            console.log('useSmartCopywriting: Auto-loading project', projectId);
            loadProject(projectId);
        }
    }, [projectId, state.project, loadProject]);

    // 跳转到指定步骤
    const goToStep = useCallback((step: CopywritingStep) => {
        setState(prev => ({ ...prev, currentStep: step }));
    }, [setState]);

    return {
        // 状态
        ...state,
        selectedAudiences: state.audiences.filter(a => a.selected),
        selectedScenarios: state.scenarios.filter(s => s.selected),

        // 操作 (由各个子 Hook 提供)
        loadProject,
        analyzeAudiences,
        selectAudiences,
        recommendScenarios,
        selectScenarios,
        generateCopy,
        saveVersion,
        regenerateSingleFABE,
        goToStep,
    };
};
